<template>
  <div class="custom-ui-toggler-wrapper" v-click-outside="close">
    <div @click="toggleDisplay()">
      <slot name="trigger" />
    </div>
    <div
      class="custom-ui-toggler"
      :class="defaultDisplay ? 'active' : ''"
      v-show="defaultDisplay"
      @click="close"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue'

  const props = defineProps({
    width: {
      type: String,
      default: '100px',
    },
    vertical: {
      type: String,
      default: 'bottom',
    },
    horizontal: {
      type: String,
      default: 'left',
    },
    display: {
      type: Boolean,
      default: false,
    },
    manualClose: {
      type: Boolean,
      default: false,
    },
  })

  const defaultDisplay = ref<boolean>(false)
  const emit = defineEmits(['toggle'])

  watch(
    () => props.display,
    val => {
      defaultDisplay.value = val
    },
  )

  const toggleDisplay = () => {
    defaultDisplay.value = !defaultDisplay.value
    emit('toggle', defaultDisplay.value)
  }

  const close = () => {
    if (props.manualClose) return
    if (defaultDisplay.value) {
      defaultDisplay.value = false
    }
  }
</script>

<style lang="scss" scoped>
  .custom-ui-toggler-wrapper {
    cursor: pointer;
    .custom-ui-toggler {
      width: v-bind(width);
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background-color: $white;
      position: absolute;
      z-index: 999;
      top: calc(100% + 5px);
      right: 0;
      opacity: 0;
      transition: 0.2s ease;
      overflow: hidden;
      &.active {
        transition: 0.2s ease;
        opacity: 1;
      }
    }
  }
</style>
